import React from 'react'
import { CrossSellStyled, CrossSellWrapper, Divider } from './CrossSell.styled'
import { useTranslation } from 'react-i18next'
import { BottomBoxes, BoxType } from './components/BottomBoxes/BottomBoxes'
import { TopPart } from './components/TopPart/TopPart'

export const PaidMarketingCrossSell = () => {
  const { t } = useTranslation('pricing')
  const boxes: Array<BoxType> = Object.values(
    t('cross-sell.paid_marketing.boxes', { returnObjects: true })
  )

  return (
    <CrossSellStyled>
      <CrossSellWrapper>
        <TopPart />
        <Divider />
        <BottomBoxes title={t('cross-sell.paid_marketing.boxes_title')} boxes={boxes} />
      </CrossSellWrapper>
    </CrossSellStyled>
  )
}
